import { PlusLoadStatus } from 'types/Order'

export function formatPlusLoadQuantityTextByStatus(qty: number | null, status: PlusLoadStatus.SUBMITTED | PlusLoadStatus.APPLIED) {
  if (qty === null) {
    return ''
  }
  if (status === PlusLoadStatus.SUBMITTED) {
    return `+ ${qty} m³ submitted `
  }
  if (status === PlusLoadStatus.APPLIED) {
    return `+ ${qty} m³ included `
  }
}
